<template>
  <div class="card card-body shadow-sm mt-0">
    <!-- Cabeçalho do Formulário de Animal -->
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">{{ animal.id ? "Editar Animal" : "Novo Animal" }}</h4>
      <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
    </div>

    <BaseForm :isFormValid="isFormValid" :isSubmitting="isSubmitting" @submit="salvarAnimal" @cancel="voltar">

      <!-- Seção Dados do Animal -->
      <FormSection title="Dados do Animal">
        <div class="form-group">
          <InputField
            id="nome"
            type="text"
            v-model="animal.nome"
            label="Nome <span class='required'>*</span>"
            :class="{ 'error-input': errors.nome }"
            placeholder="Digite o nome do animal"
            width="250px"
          />
        </div>

        <SelectField
          id="sexo"
          v-model="animal.sexo"
          label="Sexo <span class='required'>*</span>"
          :options="[
            { value: '', text: 'Selecione uma opção', disabled: true },
            { value: 'Fêmea', text: 'Fêmea' },
            { value: 'Macho', text: 'Macho' }
          ]"
          required
        />

        <div class="form-group">
          <InputField
            id="raca"
            type="text"
            v-model="animal.raca"
            label="Raça"
            placeholder="Digite a raça do animal"
            width="150px"
          />
        </div>

        <div class="form-group">
          <InputField
            id="nascimento"
            type="date"
            v-model="animal.nascimento"
            label="Data de Nascimento"
          />
        </div>

        <div class="form-group">
          <InputField
            id="data_entrada"
            type="date"
            v-model="animal.data_entrada"
            label="Data de Entrada"
          />
        </div>

        <div class="form-group">
          <label for="status" class="form-label">Status</label>
          <div class="form-switch d-flex align-items-center gap-2">
            <input
              type="checkbox"
              id="status"
              v-model="animal.ativo"
              class="form-check-input"
            />
            <label for="status" class="status-label mb-0">
              {{ animal.ativo ? "Ativo" : "Inativo" }}
            </label>
          </div>
        </div>
      </FormSection>

      <!-- Seção Observação -->
      <FormSection title="">
        <label for="observacao" class="form-label">Observação</label>
        <textarea
          id="observacao"
          v-model="animal.observacao"
          class="form-control"
          placeholder="Digite observações sobre o animal"
          rows="3"
        ></textarea>
      </FormSection>
    </BaseForm>
  </div>

</template>

<script>
import { reactive, ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/services/axios";
import BaseForm from "@/components/Layout/BaseForm.vue";
import FormSection from "@/components/Layout/FormSection.vue";
import InputField from "@/components/Layout/InputField.vue";
import SelectField from "@/components/Layout/SelectField.vue";

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  components: { BaseForm, FormSection, InputField, SelectField },
  setup() {
    const route = useRoute();
    const router = useRouter();

    // Dados do formulário de animal
    const animal = reactive({
      nome: "",
      sexo: "",
      // Removidos os campos espécie, temperamento e destinação
      nascimento: "",
      raca: "",
      proprietario_id: "",
      proprietario_nome: "",
      data_entrada: "",
      observacao: "",
      ativo: true,
    });

    // Removidos os arrays de espécies, temperamentos e destinações

    const errors = reactive({});

    // Validação e ação do formulário de animal
    const isFormValid = computed(() => {
      return (
        animal.nome.trim() !== "" &&
        animal.sexo.trim() !== "" &&
        !Object.values(errors).some((error) => error)
      );
    });

    const isSubmitting = ref(false);

    const salvarAnimal = async () => {
      if (isSubmitting.value) return;
      isSubmitting.value = true;

      if (!isFormValid.value) {
        console.error("O formulário contém erros:", errors);
        isSubmitting.value = false;
        return;
      }

      try {
        const payload = {
          nome: animal.nome,
          sexo: animal.sexo,
          nascimento: animal.nascimento || null,
          raca: animal.raca,
          data_entrada: animal.data_entrada || null,
          ativo: !!animal.ativo,
          observacao: animal.observacao,
        };

        const method = animal.id ? "put" : "post";
        const url = animal.id
          ? `/cadastros/animais/${animal.id}`
          : `/cadastros/animais`;

        await axios[method](url, payload);
        router.push("/cadastros/animais");
      } catch (error) {
        console.error("Erro ao salvar animal:", error);
      } finally {
        isSubmitting.value = false;
      }
    };

    const voltar = () => {
      router.push("/cadastros/animais");
    };

    onMounted(async () => {
      const animalId = route.params.id;
      if (animalId) {
        try {
          const response = await axios.get(
            `/cadastros/animais/${animalId}`
          );
          const data = response.data;
          animal.nome = data.nome || "";
          animal.sexo = data.sexo || "";
          // Removidos os campos espécie, temperamento e destinação
          animal.nascimento = data.nascimento ? data.nascimento.split("T")[0] : "";
          animal.raca = data.raca || "";
          animal.data_entrada = data.data_entrada ? data.data_entrada.split("T")[0] : "";
          animal.observacao = data.observacao || "";
          animal.ativo = data.ativo !== undefined ? Boolean(data.ativo) : true;
          animal.id = data.id;

        } catch (error) {
          console.error("Erro ao carregar animal ou proprietário:", error);
        }
      }
    });

    return {
      animal,
      errors,
      isFormValid,
      salvarAnimal,
      voltar,
      isSubmitting,
    };
  },
};
</script>

<style scoped>
/* Estilos existentes permanecem inalterados */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 700px;
  height: 600px;
  overflow-y: auto;
  margin: 0 10px;
  border-radius: 4px;
}

.modal-header {
  background: #ccc;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
}

.filter-label {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  margin-top: 10px;
  margin-left: 10px;
}

.filter-group {
  display: flex;
  flex-grow: 1;
  gap: 10px;
  margin-right: 40px;
}

.filter-input {
  flex: 1;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 0px;
  font-size: 10px;
  outline: none;
  transition: 0.2s;
  margin-left: 8px;
  margin-right: 15px;
}

.filter-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}

.table-container {
  margin-top: 15px;
  margin-left: 15px;
  margin-right: 15px;
}

.table th,
.table td {
  padding: 8px 10px;
  line-height: 1.2;
  vertical-align: middle;
}

.table td .btn-sm {
  padding: 4px 6px;
  font-size: 0.85rem;
  height: 15px;
  width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table th {
  background: #f1f1f1;
  font-weight: bold;
}

.table td {
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

.modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
}

.pagination-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pagination-btn {
  padding: 6px 10px;
  font-size: 14px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-text {
  font-size: 12px;
  font-weight: normal;
  color: #333;
}

.total-registros {
  position: absolute;
  left: 20px;
  font-size: 14px;
  color: #555;
}

.filter-btn {
  background: #6c757d;
  border: none;
  color: white;
  padding: 6px 12px;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-btn i {
  font-size: 18px;
}

.filter-btn:hover {
  background: #1a1b1b;
}

.toggle-buttons {
  display: flex;
  justify-content: right;
  gap: 15px;
  margin-bottom: 0px;
  margin-top: 10px;
  margin-right: 40px;
}

.toggle-buttons .btn {
  padding: 4px 10px;
  font-size: 0.8rem;
}

.small-filter-btn {
  padding: 2px 10px;
  font-size: 12px;
  line-height: 1;
}

.small-filter-btn i {
  font-size: 10px;
}
</style>
